import { SVGIconComponent } from './types';

export const EventDoorSwitched: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="27px"
    height="28px"
    viewBox="0 0 27 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g
      id="timeline/event-switched"
      stroke="none"
      fill="none"
      transform="translate(1, 1)"
      fillRule="nonzero"
      strokeWidth="0.5"
    >
      <path
        d="M10.5325223,13.1215173 C10.9892042,13.6085929 10.9892033,14.3910463 10.5325251,14.8781452 L8.77732303,16.7502664 L19.0630372,16.7502664 C19.722543,16.7502664 20.25,17.3128589 20.25,17.999643 C20.25,18.6865389 19.722453,19.2499556 19.0630372,19.2499556 L8.77732297,19.2499556 L10.5323204,21.1218587 C10.9892715,21.6080818 10.9892715,22.391785 10.5327294,22.8775718 C10.0682854,23.3741427 9.30656275,23.3741427 8.84234354,22.8778119 L5.09186179,18.8784596 C4.87239824,18.644377 4.75,18.3281756 4.75,17.999667 C4.75,17.6713061 4.87229437,17.3559738 5.09186179,17.1218104 L8.84232306,13.12152 C9.30673052,12.626177 10.0681137,12.626176 10.5325223,13.1215173 Z M16.1578813,3.12242821 L16.1576565,3.12218812 L19.9083426,7.12175861 C20.3638708,7.60879699 20.3638708,8.39093301 19.9081382,8.87818964 L16.1576769,12.87848 C15.6932686,13.373824 14.9318833,13.373824 14.4674749,12.87848 C14.0107967,12.3913811 14.0107967,11.6089297 14.4674749,11.1218308 L16.222677,9.24970962 L5.93696279,9.2497096 C5.27745703,9.2497096 4.75,8.68711712 4.75,8.000333 C4.75,7.31343706 5.27754705,6.7500204 5.93696279,6.7500204 L16.222677,6.75002042 L14.4676796,4.87811727 C14.0107285,4.39189422 14.0107285,3.60819098 14.4672758,3.12239861 C14.9317243,2.62585343 15.6934426,2.62586296 16.1578813,3.12242821 Z M10.5325251,13.12152 L10.5325223,13.1215173 C10.5325216,13.1215162 10.5325207,13.1215153 10.5325198,13.1215144 Z"
        id="Shape"
        stroke="currentColor"
        fill="currentColor"
        transform="translate(12.5, 13) rotate(45) translate(-12.5, -13)"
      ></path>
    </g>
  </svg>
);
